import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import BakeasyAppLayout from "..//components/layouts/BakeasyAppLayout";
import { history } from "../redux_store/history";
import { PrivateRoutes } from "./PrivateRoutes";
import { Home } from "../pages/home/Home";
import { routesList } from "./routesList";
import { BakeasyAccountLayout } from "../components/layouts/BakeasyAccountLayout";
import { Products } from "../pages/Products/Products";

function AppRoutes() {
	// init custom history object to allow navigation from
	// anywhere in the react app (inside or outside components)
	history.location = useLocation();
	history.navigate = useNavigate();

	return (
		<Routes>
			{/* private */}
			<Route element={<PrivateRoutes />}>
				<Route
					path="/"
					element={<BakeasyAppLayout component={<Products />} />}
				/>
				{routesList.map((routeItem: any, index) => (
					<Route
						key={index}
						path={routeItem?.path}
						element={<BakeasyAppLayout component={<routeItem.component />} />}
					/>
				))}
			</Route>
			{/* public */}
			<Route path="/*" element={<BakeasyAccountLayout />} />
			{/* {routesList.map((routeItem: any, index) => {
				return isUserAuthenticated ? (
					<Route
						key={index}
						path={routeItem?.path}
						element={<BakeasyAppLayout component={<routeItem.component />} />}
					/>
				) : (
					(window.location.href = env.LOGIN_URL)
				);
			})} */}
		</Routes>
	);
}

export default AppRoutes;
